import { render, staticRenderFns } from "./PlatformMobileTopBar.vue?vue&type=template&id=7c353056&scoped=true"
import script from "./PlatformMobileTopBar.vue?vue&type=script&lang=js"
export * from "./PlatformMobileTopBar.vue?vue&type=script&lang=js"
import style0 from "./PlatformMobileTopBar.vue?vue&type=style&index=0&id=7c353056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c353056",
  null
  
)

export default component.exports